<template>
  <div class="p-r">
    <el-button
      class="whiteListBtn p-a"
      type="primary"
      size="mini"
      :staParams="staParams"
      @click="showWhiteList"
    >
      白名单管理
    </el-button>
    <el-button
      type="primary"
      class="blackListBtn p-a"
      size="mini"
      @click="showBlackList"
    >
      黑名单管理
    </el-button>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="待领取" name="first"></el-tab-pane>
      <el-tab-pane label="进行中" name="second"></el-tab-pane>
      <el-tab-pane label="已完成" name="third"></el-tab-pane>
      <el-tab-pane label="已取消" name="four"></el-tab-pane>
    </el-tabs>
    <avue-crud
      ref="crud"
      :option="tableOption"
      :search.sync="search"
      :data="tableData"
      @on-load="getList"
      :page.sync="page"
      @sort-change="sortChange"
      @search-change="searchChange"
      v-model="search"
    >
      <template slot="fieldNameSearch">
        <el-select v-model="search.fieldCode" clearable placeholder="请选择">
          <el-option
            class="p-lr-10"
            v-for="item in industryListArr"
            :key="item.fieldId"
            :label="item.fieldName"
            :value="item.fieldId"
          >
            {{ item.fieldName }}
            <span v-if="item.isHot == 1" class="p-lr-0">（爆品）</span>
          </el-option>
        </el-select>
      </template>
      <template slot="fieldName" slot-scope="scope">
        <i class="icon-huobao c-red" v-if="scope.row.isHot == 1"></i>
        {{ scope.row.fieldName || '--' }}
      </template>
      <template slot="qcTaskId" slot-scope="scope">
        <span>
          {{ (scope.row.taskType === 1 ? '主-' : '') + scope.row.qcTaskId }}
        </span>
      </template>
      <template slot="amount" slot-scope="scope">
        <div v-if="status === 1">
          {{ scope.row.amount }}
          <el-tooltip
            :content="`额外增加机翻直出&例句直出费用${scope.row.extraAmount}元`"
            placement="top"
          >
            <span v-show="scope.row.extraAmount > 0" class="c-red p-r">
              +{{ scope.row.extraAmount }}
              <i class="el-icon-star-on c-red p-a"></i>
            </span>
          </el-tooltip>
        </div>
        <div v-else class="p-r">
          {{ scope.row.amount }}
          <el-tooltip
            :content="`含机翻直出&例句直出费用${scope.row.extraAmount}元`"
            placement="top"
          >
            <i
              v-show="scope.row.extraAmount > 0"
              class="el-icon-star-on c-red p-a"
            ></i>
          </el-tooltip>
          <span v-show="scope.row.addAmount > 0" class="c-red m-l-10">
            +{{ scope.row.addAmount }}
          </span>
        </div>
      </template>
      <template slot="amount1" slot-scope="scope">
        <div v-if="status === 1">
          {{ scope.row.amount }}
          <el-tooltip
            :content="`额外增加机翻直出&例句直出费用${scope.row.extraAmount}元`"
            placement="top"
          >
            <span v-show="scope.row.extraAmount > 0" class="c-red p-r">
              +{{ scope.row.extraAmount }}
              <i class="el-icon-star-on c-red p-a"></i>
            </span>
          </el-tooltip>
        </div>
        <div v-else class="p-r">
          {{ scope.row.amount }}
          <el-tooltip
            :content="`含机翻直出&例句直出费用${scope.row.extraAmount}元`"
            placement="top"
          >
            <i
              v-show="scope.row.extraAmount > 0"
              class="el-icon-star-on c-red p-a"
            ></i>
          </el-tooltip>
          <span v-show="scope.row.addAmount > 0" class="c-red m-l-10">
            +{{ scope.row.addAmount }}
          </span>
        </div>
      </template>
      <template slot="status" slot-scope="scope">
        <span v-if="scope.row.status === -1">已取消</span>
        <span v-if="scope.row.status === 1">进行中</span>
        <span v-if="scope.row.status === 2">待提交</span>
        <span v-if="scope.row.status === 3">已提交</span>
      </template>
      <template slot="qcOrderType" slot-scope="scope">
        {{
          scope.row.qcOrderType == 1
            ? '质控'
            : scope.row.qcOrderType == 2
            ? 'MTQC'
            : '质检'
        }}
      </template>
      <template slot="lan" slot-scope="scope">
        <span>
          {{ $sysLan.get(scope.row.slan) }}-{{ $sysLan.get(scope.row.tlan) }}
        </span>
      </template>

      <template slot="limitTime" slot-scope="scope">
        <span>
          {{ scope.row.limitTime ? formatDate(scope.row.limitTime) : '--' }}
        </span>
      </template>

      <template slot-scope="{ row, index }" slot="menu">
        <el-button
          v-if="status == 1"
          type="success"
          icon="el-icon-document"
          size="mini"
          @click="toQcDetail(row)"
          plain
        >
          预览详情后领取
        </el-button>
        <el-button
          v-if="status !== -1 && status != 1"
          type="success"
          icon="el-icon-document"
          size="mini"
          @click="toQcDetail(row)"
          plain
        >
          详情
        </el-button>
      </template>
    </avue-crud>

    <!-- 白名单管理弹窗 -->
    <whiteList
      v-if="whiteListVisible"
      :whiteListVisible="whiteListVisible"
      :staParams="staParams"
      ref="whiteListOption"
    ></whiteList>

    <!-- 黑名单管理弹窗 -->
    <blackList
      v-if="blackListVisible"
      :blackListVisible="blackListVisible"
      :staParams="staParams"
      ref="blackListOption"
    />
  </div>
</template>

<script>
import * as Sentry from '@sentry/vue';
import { pageQcFlow, getSmartCheckStatusByQcTaskId } from '@/api/qc/qcflow';
import { industry } from '@/api/qc/manage';
import { seleteById } from '@/api/dot/qc';
import { statistics } from '@/api/dot/flow';
import { mapGetters, mapState } from 'vuex';
import { tableOption } from '@/const/crud/qc/qcflow';
import { formatDate } from '@/util/date';
import blackList from './component/blackList';
import whiteList from './component/whiteList';

export default {
  components: { blackList, whiteList },
  data() {
    return {
      activeName: 'first',
      dialogVisible: false,
      dialogLimitTime: 0,
      dialogWordCount: 0,
      dialogFlowId: 0,
      page: {
        pageSize: 20,
        pagerCount: 5,
      },
      currentRow: {},
      search: {},
      tableData: [],
      tableOption: tableOption,
      status: 1,
      blackListVisible: false,
      whiteListVisible: false,
      staParams: null,
      isChangeAmount: false, //是否变更
      changeData: null,
      isChangeTime: false,
      changeTime: 0,
      isShowReciveBtn: false,
      industryListArr: [], //领域下拉列表
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.curPath = to.path;
      vm.oldPath = from.path;
    });
  },
  watch: {
    status(val) {
      //status: 1-待领取 2-进行中 3-已完成 4-已取消
      let amount = this.findObject(this.tableOption.column, 'amount');
      let amount1 = this.findObject(this.tableOption.column, 'amount1');
      let fieldName = this.findObject(this.tableOption.column, 'fieldName');
      let receiveName = this.findObject(this.tableOption.column, 'receiveName');
      if ((val === 2 || val === 3) && !this.search.isKit) {
        receiveName.hide = false;
        receiveName.search = true;
        fieldName.search = true;
      } else {
        receiveName.hide = true;
        receiveName.search = false;
        fieldName.search = false;
      }
      if (val === 1 || val === 2) {
        amount.hide = false;
        amount1.hide = true;
      } else {
        amount.hide = true;
        amount1.hide = false;
      }
    },
    'search.isKit'(val) {
      let receiveName = this.findObject(this.tableOption.column, 'receiveName');
      let fieldName = this.findObject(this.tableOption.column, 'fieldName');
      if (!val && this.status !== 1 && this.status !== 4) {
        fieldName.search = true;
        receiveName.search = true;
      } else {
        fieldName.search = false;
        receiveName.search = false;
      }
    },
  },
  created: function () {
    this.staParams = {
      u_id: this.userInfo.staffId,
      time: new Date().getTime(),
      browser: navigator.userAgent.toLowerCase(),
      url: document.URL,
      scene_name: '质控列表',
    };
  },
  computed: {
    ...mapGetters(['permissions']),
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
  },
  mounted() {
    this.statistics();
    this.getIndustryList();
  },
  methods: {
    statistics() {
      statistics(
        Object.assign(
          {
            event_type: 'view',
            ref_url: this.oldPath,
          },
          this.staParams,
        ),
      );
    },

    // 获取领域列表
    getIndustryList() {
      industry({}).then((res) => {
        this.industryListArr = res.data?.data;
      });
    },

    // 按时间排序
    sortChange(val) {
      if (val.order == 'descending') {
        this.search.orderWay = 'desc';
      } else {
        this.search.orderWay = 'asc';
      }
      this.getList(this.page, this.search);
    },

    toQcDetail(row) {
      if (this.status == 1) {
        // qcTaskId异常告警
        if (!row.qcTaskId) {
          Sentry.captureMessage(
            `[seleteById] params: ${JSON.stringify({
              qcTaskId: row.qcTaskId,
            })}, user: ${JSON.stringify(this.userInfo)}`,
          );
        }
        seleteById({
          qcTaskId: row.qcTaskId,
          isKit: row.qcOrderType === 3 ? true : false,
        }).then((res) => {
          if (!res?.data || res.data?.data?.status != 1) {
            this.$message.info('此质控任务状态已改变，请刷新页面');
            this.getList(this.page);
          } else {
            this.$router.push({
              path: '/qc/flow/' + row.flowId + '?status=' + this.status,
              query: {
                isKit: row.qcOrderType === 3 ? true : false,
                orderId: row.orderId,
                qcTaskId: row.qcTaskId,
                taskType: row.taskType,
                checkDistribute: row.checkDistribute,
                canDistribute: row.canDistribute,
                slan: row.slan,
                tlan: row.tlan,
                taskId: row.qcTaskId,
              },
            });
          }
        });
      } else {
        // 质检订单
        if (row.qcOrderType === 3) {
          if (this.status == 2) {
            seleteById({
              qcTaskId: row.qcTaskId,
              isKit: row.qcOrderType === 3 ? true : false,
            }).then((res) => {
              if (!res?.data || res.data?.data?.status != 2) {
                this.$message.info('此质控任务状态已改变，请刷新页面');
                this.getList(this.page);
              } else {
                this.$router.push({
                  path: '/qc/flow/qc-check/' + row.orderId,
                });
              }
            });
          } else {
            this.$router.push({
              path: '/qc/flow/' + row.flowId + '?status=' + this.status,
              query: {
                isKit: row.qcOrderType === 3 ? true : false,
                orderId: row.orderId,
                qcTaskId: row.qcTaskId,
                taskType: row.taskType,
                checkDistribute: row.checkDistribute,
                canDistribute: row.canDistribute,
                slan: row.slan,
                tlan: row.tlan,
                taskId: row.qcTaskId,
              },
            });
          }
        } else {
          getSmartCheckStatusByQcTaskId({ qcTaskId: row.qcTaskId }).then(
            (res) => {
              if (res.data?.data == 2) {
                this.$router.push({
                  path: '/qc/flow/uniform-check/' + row.orderId,
                  query: {
                    slan: row.slan,
                    tlan: row.tlan,
                    taskId: row.qcTaskId,
                  },
                });
              } else {
                this.$router.push({
                  path: '/qc/flow/' + row.flowId + '?status=' + this.status,
                  query: {
                    isKit: row.qcOrderType === 3 ? true : false,
                    orderId: row.orderId,
                    qcTaskId: row.qcTaskId,
                    taskType: row.taskType,
                    checkDistribute: row.checkDistribute,
                    canDistribute: row.canDistribute,
                    slan: row.slan,
                    tlan: row.tlan,
                    taskId: row.qcTaskId,
                  },
                });
              }
            },
          );
        }
      }
      statistics(
        Object.assign(
          {
            event_name: '详情',
            event_type: 'click',
          },
          this.staParams,
        ),
      );
    },

    // 打开黑名单管理弹窗
    showBlackList() {
      this.blackListVisible = true;
      this.$nextTick(() => {
        this.$refs.blackListOption.init();
      });
      this.staParams = {
        u_id: this.userInfo.staffId,
        time: new Date().getTime(),
        browser: navigator.userAgent.toLowerCase(),
        url: document.URL,
        scene_name: '质控列表',
      };
    },

    // 打开白名单管理弹窗
    showWhiteList() {
      this.whiteListVisible = true;
      this.$nextTick(() => {
        this.$refs.whiteListOption.init();
      });
      this.staParams = {
        u_id: this.userInfo.staffId,
        time: new Date().getTime(),
        browser: navigator.userAgent.toLowerCase(),
        url: document.URL,
        scene_name: '质控列表',
      };
    },

    btnReturnSuccess(msg = '提交成功', path = '/refresh', fn) {
      this.$message.success({
        message: msg,
        duration: 1500,
        onClose: () => {
          if (fn) {
            fn();
          }
          this.$router.replace({
            path: path || '/refresh',
          });
        },
      });
    },

    btnReturnFail(msg = '提交失败', path = '/refresh', fn) {
      this.$message.error({
        message: msg,
        duration: 1500,
        onClose: () => {
          if (fn) {
            fn();
          }
          this.$router.replace({
            path: path || '/refresh',
          });
        },
      });
    },

    searchChange(form, done) {
      this.search = form;
      this.page.currentPage = 1;
      this.getList(this.page, form);
      done();
    },

    formatDate(time) {
      let date = new Date(parseFloat(time));
      return formatDate(date, 'yyyy-MM-dd hh:mm');
    },
    getList(page, params) {
      pageQcFlow(
        Object.assign(
          {
            current: page.currentPage,
            size: page.pageSize,
            qcId: this.userInfo.staffId,
            status: this.status,
          },
          params,
          this.search,
        ),
      ).then((response) => {
        this.tableData = response.data.data.records;
        this.page.total = response.data.data.total;
      });
    },

    handleClick(tab, event) {
      if (tab.name === 'first') this.status = 1;
      if (tab.name === 'second') this.status = 2;
      if (tab.name === 'third') this.status = 3;
      if (tab.name === 'four') this.status = -1;

      this.getList(
        {
          total: 0, // 总页数
          currentPage: 1, // 当前页数
          pageSize: 20, // 每页显示多少条
        },
        tab.name === 'five' ? 1 : null,
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.blackListBtn {
  right: 20px;
  z-index: 99;
}
.whiteListBtn {
  right: 120px;
  z-index: 99;
}
.c-danger:hover {
  color: #f56c6c;
  text-decoration: underline;
}
.el-button--text:focus,
.el-button--text:hover {
  text-decoration: underline;
}
.avue-view {
  background: #ffffff;
  padding: 20px;
}

:deep(.avue-group--card:last-child) {
  margin-bottom: 0px !important;
}

.el-table__body tr.hover-row.current-row > td,
.el-table__body tr.hover-row.el-table__row--striped.current-row > td,
.el-table__body tr.hover-row.el-table__row--striped > td,
.el-table__body tr.hover-row > td {
  background-color: unset;
}

.el-table__expanded-cell[class*='cell'] {
  padding: 10px 10px 10px 60px;
}
:deep(.el-table__expanded-cell) {
  tr.hover-row {
    background-color: unset !important;
    td {
      background-color: unset !important;
    }
  }
}

:deep(.el-table__expanded-cell[class*='cell']) {
  padding: 10px;
}
.dialog-div {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
}
.slef-footer {
  display: flex;
  justify-content: space-around;
}
</style>
